module.exports = __webpack_public_path__ + "static/media/student-score-scorebox.1fc5fca2.png";